import SDIcon from './SDIcon'

const IconCarbonContentView = (props) => (
  <SDIcon title='ContentView' {...props}>
    <circle cx='16' cy='19' r='2' />
    <path d='M23.7769,18.4785A8.64,8.64,0,0,0,16,13a8.64,8.64,0,0,0-7.7769,5.4785L8,19l.2231.5215A8.64,8.64,0,0,0,16,25a8.64,8.64,0,0,0,7.7769-5.4785L24,19ZM16,23a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,23Z' />
    <path d='M27,3H5A2,2,0,0,0,3,5V27a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V5A2,2,0,0,0,27,3ZM5,5H27V9H5ZM5,27V11H27V27Z' />
  </SDIcon>
)

export default IconCarbonContentView
